import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M25.173 8h-2.574v12.887h2.574V8ZM19.635 8.721H17.06v12.887h2.575V8.72ZM14.112 9.526h-2.574v12.89h2.574V9.526ZM8.574 10.34H6v12.891h2.574v-12.89Z" }, null, -1)
  ]))]))
}
export default { render: render }